import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { computed } from 'vue'

export interface SelectedRegisterToLoadInterface {
  endpoint: string
  context: string
  post?: Record<string, any>
}

export default function useSelectedRegister({ entityName }: { entityName: string }) {
  // GETTERS
  const selectedRegisterId = computed(() =>
    store.getters[`${ModuleNamespaces.SELECTED_REGISTER}/getSelectedRegisterId`](entityName).toString()
  )

  const selectedRegisterData = computed(() =>
    store.getters[`${ModuleNamespaces.SELECTED_REGISTER}/getSelectedRegisterData`](entityName)
  )

  const getSelectedRegisterByEntity = (entityId: string) => {
    return store.getters[`${ModuleNamespaces.SELECTED_REGISTER}/getSelectedRegisterData`](entityId)
  }

  const getSelectedRegisterId = (context: string) =>
    store.getters[`${ModuleNamespaces.SELECTED_REGISTER}/getSelectedRegisterId`](context)

  // ACTIONS
  const loadSelectedRegister = (selectedRegisterToLoad: SelectedRegisterToLoadInterface) =>
    store.dispatch(`${ModuleNamespaces.SELECTED_REGISTER}/fetchSelectedRegisterData`, selectedRegisterToLoad)

  const loadSelectedRegisterWithPost = async (params: {
    endpoint: string
    context: string
    post: Record<string, any>
  }) => {
    return await store.dispatch(`${ModuleNamespaces.SELECTED_REGISTER}/fetchSelectedRegisterData`, params)
  }

  const saveSelectedRegisterData = (selectedRegisterData: any, context: string = entityName) => {
    store.dispatch(`${ModuleNamespaces.SELECTED_REGISTER}/saveSelectedRegisterData`, { selectedRegisterData, context })
  }

  const saveSelectedRegisterId = (id: any, context: string) => {
    store.dispatch(`${ModuleNamespaces.SELECTED_REGISTER}/saveSelectedRegisterId`, { id, context })
  }

  // MUTATIONS
  const removeSelectedRegisterDataContext = (context: string = entityName) => {
    store.commit(`${ModuleNamespaces.SELECTED_REGISTER}/REMOVE_SELECTED_REGISTER_DATA_CONTEXT`, context)
  }

  return {
    getSelectedRegisterByEntity,
    getSelectedRegisterId,
    loadSelectedRegister,
    loadSelectedRegisterWithPost,
    saveSelectedRegisterData,
    saveSelectedRegisterId,
    removeSelectedRegisterDataContext,
    entityName,
    selectedRegisterId,
    selectedRegisterData
  }
}
